import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function TraitIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 24 24" {...props}>
      <rect width="22.284" height="22.284" x="1.141" y=".762" stroke="#F9BA3E" strokeWidth=".969" rx="5.329" />
      <path
        fill="#F9BA3E"
        d="M12.282 6.091a.427.427 0 0 0-.21.054L7.279 8.828a.456.456 0 0 0 0 .786l1.695.948-1.695.949a.441.441 0 0 0-.227.393.456.456 0 0 0 .227.393l1.695.948-1.695.949a.456.456 0 0 0 0 .786l4.795 2.682a.427.427 0 0 0 .419 0l4.794-2.683a.442.442 0 0 0 .228-.393.456.456 0 0 0-.228-.393l-1.694-.948 1.694-.948a.456.456 0 0 0 0-.786l-1.694-.949 1.694-.948a.441.441 0 0 0 .228-.393.456.456 0 0 0-.228-.393l-4.794-2.683a.427.427 0 0 0-.21-.054Zm0 .957 3.884 2.173-1.696.948-2.188 1.225L8.4 9.22l3.883-2.173Zm-2.397 4.024 2.188 1.225a.428.428 0 0 0 .419 0l2.188-1.225 1.486.832-1.694.948-2.19 1.224-2.193-1.226-1.69-.946 1.486-.832Zm0 2.683 2.188 1.224a.427.427 0 0 0 .419 0l2.188-1.224 1.486.831-3.884 2.173L8.4 14.586l1.486-.83Z"
      />
    </Icon>
  );
}
